import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class PresidentContainer extends ShadowDOMElement {
	static className = "PresidentContainer";
	
	render() {
    return html`
      <checkbox-field
        label="Président du Conseil d'administration"
        id-input="chkPresident"
		id="chk-president"
        name="president"
        @change="${this.handleCheckboxChange}"
      ></checkbox-field>
      <div-container id="president-container" visible="false">
        <row-wrapper>
          <text-field label="Nombre d'exercices *" required name="number_of_exercises" disable-autocomplete></text-field>
        </row-wrapper>
        <row-wrapper>
          <date-field label="Date de fin d'exercice *" required name="date_exercises"></date-field>
        </row-wrapper>
        <personne-container></personne-container>
      </div-container>
    `;
    }

	handleCheckboxChange(event){
		const presidentContainer = this.shadowRoot.querySelector("#president-container");
		if (presidentContainer)
			presidentContainer.visible = event.target.checked;
	}
	
	isTransient (){
		return false;
	}
	
	#updateContainers (){
		const visible = this.shadowRoot.querySelector ("#chk-president").checked;
		this.shadowRoot.querySelector ("#president-container").visible = visible;
	}
	
	setValues (values){
		super.setValues (values);
		this.#updateContainers ();
		this.requestUpdate ();
	}
}

customElements.define("president-container", PresidentContainer);
